export default "__VITE_ASSET__Cjiub3Qx__"